// extracted by mini-css-extract-plugin
export default {"container":"Header_container__MzhU1","left":"Header_left__I6IZC","right":"Header_right__NIqGy","item":"Header_item__FHtUx","center":"Header_center__NlXng"};